'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UILoadingOverlay from 'UIComponents/loading/UILoadingOverlay';
import * as RequestState from '../../requestStates/RequestState';

const getIsRequestState = (currentRequestStatus, requestState, inclusive) => {
  if (Array.isArray(currentRequestStatus)) {
    if (inclusive) {
      return currentRequestStatus.every(status => status === requestState);
    } else {
      return currentRequestStatus.some(status => status === requestState);
    }
  }

  return currentRequestStatus === requestState;
};

export default function LoadingWrapper({
  children,
  ErrorComponent,
  errorMessage,
  LoadingComponent,
  showOverlay,
  requestStatus,
  showLoadingOnUninitialized
}) {
  const isUninitialized = useMemo(() => getIsRequestState(requestStatus, RequestState.UNINITIALIZED, true), [requestStatus]);
  const isLoading = useMemo(() => getIsRequestState(requestStatus, RequestState.PENDING, false), [requestStatus]);
  const isSucceeded = useMemo(() => getIsRequestState(requestStatus, RequestState.SUCCEEDED, true), [requestStatus]);
  const isError = useMemo(() => getIsRequestState(requestStatus, RequestState.FAILED, false), [requestStatus]);

  if (isLoading || isUninitialized && showLoadingOnUninitialized) {
    if (LoadingComponent) {
      return /*#__PURE__*/_jsx(LoadingComponent, {});
    } else if (showOverlay) {
      return /*#__PURE__*/_jsxs("div", {
        style: {
          position: 'relative'
        },
        children: [/*#__PURE__*/_jsx(UILoadingOverlay, {
          contextual: true
        }), children]
      });
    } else {
      return /*#__PURE__*/_jsx(UILoadingSpinner, {});
    }
  }

  if (isSucceeded) {
    return children;
  }

  if (isError) {
    if (ErrorComponent) {
      return /*#__PURE__*/_jsx(ErrorComponent, {});
    } else {
      return /*#__PURE__*/_jsx(UIAlert, {
        type: "danger",
        children: errorMessage || /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-ui-common.loadingWrapperDefaultError"
        })
      });
    }
  } else {
    return null;
  }
}
LoadingWrapper.propTypes = {
  children: PropTypes.node,
  ErrorComponent: PropTypes.elementType,
  errorMessage: PropTypes.node,
  LoadingComponent: PropTypes.elementType,
  showOverlay: PropTypes.bool,
  requestStatus: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  showLoadingOnUninitialized: PropTypes.bool
};
LoadingWrapper.defaultProps = {
  showOverlay: false,
  showLoadingOnUninitialized: true
};